import React from 'react'
import Translator from '../Translator.js'

import { useModalContext } from '../context/ModalContext.js'

function Other() {
    let l = Translator()
    const {showModal, setShowModal, data, setData} = useModalContext()
    const Urunler = [
        {
          ad: l.Other.otherIsim1, 
          icerik: l.Other.otherIcerik1, 
          img: "#", 
          fiyat: '150',
        },
        {
          ad: l.Other.otherIsim2, 
          icerik: l.Other.otherIcerik2, 
          img: "#", 
          fiyat: '150',
        },
        {
          ad: l.Other.otherIsim3, 
          icerik: l.Other.otherIcerik3, 
          img: "#", 
          fiyat: '150',
        },
        {
          ad: l.Other.otherIsim4, 
          icerik: l.Other.otherIcerik4, 
          img: "#", 
          fiyat: '150',
        },
        {
          ad: l.Other.otherIsim5, 
          icerik: l.Other.otherIcerik5, 
          img: "#", 
          fiyat: '150',
        },
       
      ]
  return (
    <div>
    <div className="flex flex-col w-full p-5 border-b-4 border-gray-700">
      <h1 className="text-4xl font-bold text-red-600 text-center">{l.Main.btn8}</h1>
      {Urunler.map((item, i) => [
        <div key={i}>
        <div className="flex flex-col items-left justify-between py-2 border-4 mt-2 shadow-xl rounded-sm border-gray-700">
          <div className="cursor-pointer text-xl px-5 font-semibold" onClick={() => {setData(item.img); setShowModal(true)}}>{item.ad}</div>
          <div className="text-md px-5 font-thin">{item.icerik}</div>
          <div className="text-md px-5 font-black text-blue-600">{item.fiyat}₺</div>
        </div>
      </div>
      ])}
    </div>
  </div>
  )
}

export default Other